import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {User} from '../users';
import {Employee} from '../employees';

class MassUpdateSummary extends DomainObject {
  createdAt;
  createdByUser;
  employees;
  effectiveDate;
  status;
  errorCount;

  _relations = {
    _dates: ['effectiveDate', 'createdAt'],
    createdByUser: User,
    employees: [Employee]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      createdAt: observable,
      createdByUser: observable,
      employees: observable,
      effectiveDate: observable,
      status: observable,
      errorCount: observable
    });

    this.merge(other);
  }
}

export default MassUpdateSummary;
